export default {
  'cart.index': '/cart',
  'cookies.accept': '/cookies/accept',
  'products.search': '/products',
  'products.search.config': '/products/search-config',
  'products.query.facets': '/products/query/facets',
  'products.query': '/products/query',
  'pdf.product_list': '/products/download',
  'login': '/login',
  'password.request': '/password/reset',
  'account.register': '/register',
  'representatives.contact': '/representatives/contact',
  'representatives.fetch-countries': '/representatives/countries',
  'representatives.fetch-regions': '/representatives/regions',
  'representatives.fetch-states': '/representatives/states',
}
